import {
  SearchResultDetails,
  SendPaymentRequestActionInput,
  TripUserPaymentMethod,
} from "@cruisen/contract"
import { RoomBookingDetails, RoomPaymentRequest } from "@cruisen/react-shared"
import { v4 as uuidv4 } from "uuid"

export const getFakeBookingDetails = () => {
  const paymentRequest: RoomPaymentRequest = {
    id: uuidv4(),
    status: "confirmed",
    senderId: uuidv4(),
    assignedTo: [uuidv4()],
    lineItems: [
      {
        id: uuidv4(),
        type: "cabinBooking",
        paymentPlan: "total",
        label: "Cabin A123",
        description: "Cabin A123, deck 206, cruise Western Caribbean Cruise",
        total: "1499.98",
        created: Date.now(),
        updated: Date.now(),
        meta: {
          deckId: 206,
          cabinNo: "A123",
          deckName: "Deck 02",
          cruiseShipId: 16,
          cabinGradeName: "Inside",
          cabinGradeType: "inside",
          cruiseSailingId: 359,
        },
      },
    ],
    created: Date.now(),
    updated: Date.now(),
  }

  const bookingDetails: RoomBookingDetails = {
    status: "booked",
    confirmationFile: {
      // It is a cruisen logo image - for demo purposes
      url: "https://firebasestorage.googleapis.com/v0/b/cruisen-production.appspot.com/o/cruisenLogo.png?alt=media",
      type: "image",
    },
    cabinName: "",
    cabinNo: "1234",
    cabinGradeCode: null,
    cabinFareCode: null,
    deckId: 206,
    cabinPosition: null,
    deckName: "Deck 02",
    cabinGrade: "inside",
  }

  return { paymentRequest, bookingDetails }
}

export const generateFakeProfileGridData = ({ firstName }: { firstName: string }) => {
  return {
    personalInfo: [
      {
        label: "Title",
        value: firstName === "John" ? "Mr" : "Ms",
      },
      {
        label: "First",
        value: firstName,
      },
      {
        label: "Last",
        value: "Smith",
      },
      {
        label: "Date of birth",
        value: "01/01/1990",
      },
      {
        label: "Nationality",
        value: "United States",
      },
      {
        label: "Phone",
        value: "+1 234 567 890",
      },
      {
        label: "Email",
        value: `${firstName?.toLowerCase()}@example.com`,
      },
    ],
    passportDetails: [
      {
        label: "Passport number",
        value: "1234567890",
      },
      {
        label: "Issuing country",
        value: "United States",
      },
      {
        label: "Expire date",
        value: "01/01/2025",
      },
    ],
    residence: [
      {
        label: "Address",
        value: "123 Main St",
      },
      {
        label: "City",
        value: "Anytown",
      },
      {
        label: "State",
        value: "CA",
      },
      {
        label: "Zip code",
        value: "12345",
      },
      {
        label: "Country",
        value: "United States",
      },
    ],
    cruiseLineLoyaltyMembers: [
      {
        label: "Carnival Cruise Line",
        value: "1234567890",
      },
      {
        label: "Royal Caribbean",
        value: "0987654321",
      },
    ],
  }
}

export const getMockedPaymentRequest = ({
  tripId,
  roomId,
  cruiseDetailsData,
}: {
  tripId: string
  roomId: string
  cruiseDetailsData: SearchResultDetails
}): SendPaymentRequestActionInput => {
  const firstDeck = cruiseDetailsData?.decks[0]

  const paymentRequest = {
    tripId,
    label: "Demo Cabin Booking",
    assignedTo: [uuidv4()],
    meta: {
      isDemo: true,
    },
    lineItems: [
      {
        type: "cabinBooking" as const,
        tripRoomId: roomId,
        currency: "USD",
        amount: "1299.99",
        taxesAndFees: "199.99",
        total: "1499.98",
        totalDueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
        deposit: "500.00",
        label: "Cabin A123",
        description: "Cabin A123, deck 206, cruise Western Caribbean Cruise",
        meta: {
          cabinGradeName: "Inside",
          cabinGradeType: "inside" as const,
          cabinNo: "A123",
          cruiseSailingId: cruiseDetailsData?.tripSearchResult.cruiseSailingId,
          cruiseShipId: cruiseDetailsData?.ship.id,
          deckId: firstDeck?.id || 0,
          deckName: firstDeck?.name || "",
        },
      },
    ],
  }

  return { paymentRequest }
}

export const getMockedPaymentMethods = (): TripUserPaymentMethod[] => {
  return [
    {
      id: "card_28",
      userId: uuidv4(),
      paymentMethodDetails: {
        displayName: "•••• 4242",
        type: "card",
        displayType: "card-visa",
        imagePath: "payment-methods/card-visa.png",
      },
      tokenizedCreditCard: {
        id: 28,
        userId: uuidv4(),
        tokenId: uuidv4(),
        tokenUpdated: null,
        brandId: "visa",
        cardType: "VIS",
        cardBin: "424242",
        cardLast4: "4242",
        cardholderName: "John Smith",
        expiryMonth: 12,
        expiryYear: new Date().getFullYear() + 1,
        billingAddress: null,
        created: new Date().toISOString(),
        updated: new Date().toISOString(),
        signatureExpired: null,
        signatureExpireAt: null,
      },
    },
  ]
}
